// frontend/src/components/ModalBasic.js
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

// const ModalBasic = ({
//   isOpen,
//   toggle,
//   title,
//   children,
//   primaryAction,
//   primaryActionLabel,
//   secondaryAction,
//   secondaryActionLabel,
//   isLoading,
// }) => {
//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
//       {" "}
//       <ModalHeader toggle={toggle}>{title}</ModalHeader>
//       <ModalBody>{children}</ModalBody>
//     </Modal>
//   );
// };
const ModalBasic = ({
  isOpen,
  toggle,
  title,
  children,
  size = "lg" /* Default a lg */,
}) => {
  // Añadir prop size
  return (
    // Usar la prop size, puedes pasar "xl" desde DashboardPage si "lg" no es suficiente
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size={size}
      className="form-serie-modal"
    >
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};
export default ModalBasic;
